import { GetGroupTopGoals as GetGroupTopGoalsAction } from "../../providers/supabase-provider/actions/GetGroupTopGoals";
import type { GetGroupTopGoalsPayload, ITopGoals } from "../../entities";

export const GetGroupTopGoals = async (payload: GetGroupTopGoalsPayload): Promise<ITopGoals[]> => {
  return GetGroupTopGoalsAction(payload);
};
